import * as React from 'react'
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import isBrowser from '../../services/isBrowser';

export const Gallery = ({ galleryPhotos, imgAlts }: { galleryPhotos: ImageDataLike[], imgAlts: string[] }) => {
    const [imagePopUpOpen, setImagePopUpOpen] = React.useState(false)
    const [modalWasOpen, setModalWasOpen] = React.useState(false)
    const [clickedImageData, setClickedImageData] = React.useState(null)
    const scrollRef = React.useRef(null)


    const showImageModal = (gatsbyImageData: any) => {
        setImagePopUpOpen(prev => !prev)
        setClickedImageData(gatsbyImageData)
        setTimeout(() => { if (isBrowser()) window.scrollTo(0, 0) }, 1)
        setModalWasOpen(true)
    }
    const closeImageModal = () => {
        setImagePopUpOpen(false)
        setClickedImageData(null)
    }
    // React.useEffect(() => {
    //     if (imagePopUpOpen) {
    //         document.body.classList.add('disable--scroll')
    //     }
    //     if (!imagePopUpOpen && modalWasOpen) {
    //         document.body.classList.remove('disable--scroll')
    //         if (isBrowser()) {
    //             window.scrollTo(0, (scrollRef.current.offsetTop - 250),)
    //         }
    //     }
    // }, [imagePopUpOpen, modalWasOpen])
    const filteredGalleryPhotos = galleryPhotos.slice(0, 9);
    const numberOfPhotos = filteredGalleryPhotos.length;
    const cols = getNumberOfColumns(numberOfPhotos);
    return (
        <div
            className={`flex flex-wrap gap-[3px] w-full justify-center m-auto
            ${cols == 1 && 'xl:w-[72.5%]'}
        `}>
            {filteredGalleryPhotos.map((image, index) =>
                <GatsbyImage loading='lazy' key={index} alt={imgAlts[index]} image={getImage(image)}
                    className={`basis-full grow-0 shrink-1 
                    ${cols == 2 ? 'sm:basis-[calc(50%-4px)]' : ''} 
                    ${cols == 3 ? 'sm:basis-[calc(50%-4px)] xl:basis-[calc(33.3%-4px)]' : ''}
                    max-h-[230px] xm:max-h-[300px]
                    ${cols == 1 ? 'sm:max-h-[400px] md:max-h-[450px] lg:max-h-[500px] xl:max-h-[560px] xxl:max-h-[630px]' : ''} 
                    ${cols == 2 ? 'md:max-h-[360px] lg:max-h-[400px] xl:max-h-[440px] xxl:max-h-[480px]' : ''}  
                    ${cols == 3 ? 'md:max-h-[360px] lg:max-h-[400px] xxl:max-h-[420px]' : ''}`}
                    sizes={`
                    ${cols == 1 ? '100vw' : ''} 
                    ${cols == 2 ? '(min-width: 992px) 50vw, 100vw' : ''} 
                    ${cols == 3 ? '(min-width: 992px) 50vw, (min-width: 1380px) 35vw, 100vw' : ''}`}
                />
            )}
            {/* { imagePopUpOpen && <div className="gallery__modal center" onClick={closeImageModal}>
              <div className="gallery__modal__overlay"/>

                  <GatsbyImage alt={''} image={clickedImageData} className="gallery__modal__image"/>
            </div>
            } */}
        </div>)

}


const getNumberOfColumns = (numberOfPhotos: number) => {
    if (numberOfPhotos === 1) {
        return 1;
    }
    else if (numberOfPhotos === 3 || numberOfPhotos % 3 === 0) {
        return 3;
    }
    else if (numberOfPhotos % 2 === 0 || numberOfPhotos % 3 === 1) {
        return 2;
    }
    return 3;

}